/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actionconfirmtitle2Inputs */

const en_actionconfirmtitle2 = /** @type {(inputs: Actionconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send this action?`)
};

const de_actionconfirmtitle2 = /** @type {(inputs: Actionconfirmtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion schalten?`)
};

/**
* | output |
* | --- |
* | "Send this action?" |
*
* @param {Actionconfirmtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionconfirmtitle2 = /** @type {((inputs?: Actionconfirmtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionconfirmtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionconfirmtitle2(inputs)
	return de_actionconfirmtitle2(inputs)
});
export { actionconfirmtitle2 as "actionConfirmTitle" }